export const allPermissionsName = 'ALL';